import { AnalysisFormData } from './types';
import i18n from '../i18n/config';
import xss from 'xss';

const ANALYSIS_WEBHOOK_URL = 'https://hook.eu2.make.com/bx5hpfjlnfiw6413w9xt5jo3iu2byeo5';

const sanitizeData = (data: AnalysisFormData) => {
  return {
    ...data,
    firstName: xss(data.firstName),
    lastName: xss(data.lastName),
    email: xss(data.email),
    phone: xss(data.phone),
    website: xss(data.website),
    businessType: xss(data.businessType),
    monthlyRevenue: xss(data.monthlyRevenue),
    marketingBudget: xss(data.marketingBudget),
    referralSource: xss(data.referralSource),
    mainChallenges: xss(data.mainChallenges)
  };
};

export const sendAnalysisToWebhook = async (data: AnalysisFormData) => {
  try {
    const sanitizedData = sanitizeData(data);

    const response = await fetch(ANALYSIS_WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ...sanitizedData,
        language: i18n.language
      })
    });

    if (!response.ok) {
      throw new Error(`Webhook failed: ${response.statusText}`);
    }

    return true;
  } catch (error) {
    console.error('Analysis webhook submission failed:', error);
    throw error;
  }
};